import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const RunnerComments = styled.article`
  display: flex;
  flex-direction: column;

  & > div {
    margin-bottom: ${({ theme }) => theme.space["space-6"]};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const CommentsContainer = styled.div`
  @media screen and ${breakpoints.tablet.max.sm} {
    padding: ${({ theme }) =>
      `0 ${theme.space["space-4"]} ${theme.space["space-4"]} ${theme.space["space-4"]}`};
  }
`;
